export function mobileHeight() {
    const isTouch = this.isTouch;
    const _window = this._window;
    const _document = this._document;
    let vh = _window.innerHeight * 0.01;

    if(isTouch) {
        _document.documentElement.style.setProperty("--vh", `${vh}px`);
    
        _window.addEventListener("resize", () => {
            vh = _window.innerHeight * 0.01;
            _document.documentElement.style.setProperty("--vh", `${vh}px`);
        });
    }
    
}


// WEBPACK FOOTER //
// ./assets/js/modules/mobile-height.js